import { AllvalueAdditionTwoResponse, ValueAdditionIdRequest, valueAdditionIdResponse, valueAdditionTwoResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAdditionTwoDTO } from './dto/value-addition-two.dto';
import { ValueAdditionTwoRequest } from './dto/value-addition-two.request';
import { ValueAddition2TypesService } from './value-addition2-types.service';

@ApiTags('value-addition2-types')
@Controller('value-addition2-types')
export class ValueAddition2TypesController {
    constructor(
        private valAddTwoTypeService: ValueAddition2TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

       /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/createValAddTwoType')
    async createValAddTwoType(@Body() valAddDto:ValueAdditionTwoDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionTwoResponse> {
        try {
         return await this.valAddTwoTypeService.createValAddTwoType(valAddDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionTwoResponse, error);
       }
     }

      /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllActiveValAddTwoTypes')
    async getAllActiveValAddTwoTypes(): Promise<AllvalueAdditionTwoResponse> {
        try {
            return await this.valAddTwoTypeService.getAllActiveValAddTwoTypes();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllvalueAdditionTwoResponse, error);
        }
    }

          /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

           @Post('/getAllValAddTypes')
           async getAllValAddTwoTypes(@Body() req?:UserRequestDto): Promise<AllvalueAdditionTwoResponse> {
               try {
                   return await this.valAddTwoTypeService.getAllValAddTwoTypes(req);
               } catch (error) {
                   return this.applicationExceptionHandler.returnException(AllvalueAdditionTwoResponse, error);
               }
           }

    

     /**
     * Activate Or De-Activate Value AdditionTwo Type
     * @param getSingleValAdditionTyoe AdditionTwoType 
     * @returns Value AdditionTwoTypeResponse
     */
   @Post('/activateOrDeactivateValAddTwoType')
   async activateOrDeactivateValAddTwoType(@Body() valAddTwoReq: ValueAdditionTwoRequest): Promise<valueAdditionTwoResponse> {
       try {
           return await this.valAddTwoTypeService.activateOrDeactivateValAddTwoType(valAddTwoReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(valueAdditionTwoResponse, err);
       }
   }

    /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
     @Post('/updateValAddTwoType')
     async updateValAddTwoType(@Body() valAddDto:ValueAdditionTwoDTO,isUpdate:boolean=true,@Req() request:Request): Promise<valueAdditionTwoResponse> {
         try {
          return await this.valAddTwoTypeService.createValAddTwoType(valAddDto,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(valueAdditionTwoResponse, error);
        }
      }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
    @Post('/getValAddDetails')
    async getValAddDetails(@Body() valAddOneReq: ValueAdditionIdRequest): Promise<valueAdditionIdResponse> {
        try {
            return await this.valAddTwoTypeService.getValAddDetails(valAddOneReq.valueAdditionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionIdResponse, error);
        }
    }  
}
